import { useEffect } from 'react';
import { Coffee, Mail } from 'lucide-react';
import Seo, { SEO } from '../components/Seo';

export default function Support() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdnjs.buymeacoffee.com/1.0.0/button.prod.min.js';
    script.setAttribute('data-name', 'bmc-button');
    script.setAttribute('data-slug', 'pixelutility');
    script.setAttribute('data-color', '#FFDD00');
    script.setAttribute('data-emoji', '');
    script.setAttribute('data-font', 'Cookie');
    script.setAttribute('data-text', 'Buy me a coffee');
    script.setAttribute('data-outline-color', '#000000');
    script.setAttribute('data-font-color', '#000000');
    script.setAttribute('data-coffee-color', '#ffffff');
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <>
      <Seo {...SEO.support} />
    <div className="pt-28 pb-20 px-4">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-16 h-16 rounded-2xl bg-accent-100 flex items-center justify-center mx-auto mb-6">
          <Coffee size={30} className="text-accent-500" />
        </div>

        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
          Support PixelUtility
        </h1>

        <p className="text-lg text-gray-600 leading-relaxed mb-3">
          PixelUtility is an independent project focused on creating useful, free tools for everyone.
        </p>
        <p className="text-gray-500 mb-10">
          If these tools help you, consider supporting future development — every contribution keeps us going.
        </p>

        <div className="flex justify-center mb-14">
          <a
            href="https://www.buymeacoffee.com/pixelutility"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-accent-400 text-gray-900 font-semibold hover:bg-accent-300 transition-colors shadow-sm text-lg"
          >
            <Coffee size={20} />
            Buy me a coffee
          </a>
        </div>

        <div className="border-t border-gray-100 pt-10">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">Contact Us</h2>
          <div className="flex items-center justify-center gap-2 text-gray-500 mb-3">
            <Mail size={18} />
            <span className="font-medium">Need help?</span>
          </div>
          <p className="text-gray-500">
            If you need support, please send us an email at{' '}
            <a href="mailto:info@pixelutility.com" className="text-brand-600 font-medium hover:underline">
              info@pixelutility.com
            </a>
          </p>
        </div>
      </div>
    </div>
    </>
  );
}
